import React, {useContext, useMemo, useEffect} from "react";
import {GlobalContext} from "../contexts/Provider";

const FormTypeSwitcher = () => {
    const {
        state: {formType, productId, categoryId ,store, availableMeetingForm},
        dispatch,
    } = useContext(GlobalContext);

    const meetingEnabled = useMemo(
        () => (availableMeetingForm || store?.id !== 3) && (productId || categoryId),
        [availableMeetingForm, store?.id, productId, categoryId]
    );

    useEffect(() => {
        if (formType === "meeting" && !meetingEnabled) {
            dispatch({ type: "CHANGE_TYPE", payload: "contact" });
        }
    }, [formType, meetingEnabled, dispatch]);

    const checked = formType === "meeting";

    return (
        <div className={(productId || categoryId) ? "block" : "hidden"}>
            {(productId || categoryId) && (
                <>
                    <label className="flex items-center gap-3 mt-4 select-none">
                        <input
                            type="checkbox"
                            className="switch-input"
                            checked={checked}
                            disabled={!meetingEnabled}
                            onChange={(e) =>
                                dispatch({
                                    type: "CHANGE_TYPE",
                                    payload: e.target.checked ? "meeting" : "contact",
                                })
                            }
                        />
                        <span className="text-sm text-neutrals-400">
                            Ich möchte einen Termin im Geschäft vereinbaren
                            {!meetingEnabled && " (in diesem Geschäft ist keine Terminreservierung möglich)"}
                        </span>
                    </label>
                </>
            )}
        </div>
    );
};

export default FormTypeSwitcher;
